var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconBarzahlung(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.001,
    height: 24.001,
    viewBox: "0 0 24.001 24.001",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0,19v2c0,1.655,4.031,3,9,3s9-1.345,9-3V19c-1.936,1.364-5.475,2-9,2S1.936,20.363,0,19ZM15,6c4.969,0,9-1.345,9-3S19.97,0,15,0,6,1.345,6,3,10.032,6,15,6ZM0,14.082V16.5c0,1.655,4.031,3,9,3s9-1.345,9-3V14.082c-1.936,1.594-5.48,2.419-9,2.419S1.936,15.676,0,14.082Zm19.5.516c2.686-.52,4.5-1.486,4.5-2.6V10a11.512,11.512,0,0,1-4.5,1.617ZM9,7.5c-4.969,0-9,1.678-9,3.75S4.031,15,9,15s9-1.678,9-3.75S13.969,7.5,9,7.5Zm10.28,2.639C22.093,9.633,24,8.639,24,7.5v-2c-1.664,1.177-4.524,1.809-7.533,1.959A5.249,5.249,0,0,1,19.28,10.139Z",
    fill: "#124395"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBarzahlung);
export default __webpack_public_path__ + "static/media/icon-barzahlung.e545be2c0ba774f03fe30870454c887b.svg";
export { ForwardRef as ReactComponent };